import { render, staticRenderFns } from "./AdminFrameworkCategories.vue?vue&type=template&id=a547beb2"
import script from "./AdminFrameworkCategories.vue?vue&type=script&lang=js"
export * from "./AdminFrameworkCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports